import { createReducer, on } from '@ngrx/store';
import {
  loadOccupationFailure,
  loadOccupationSuccess,
  toggleOccupationLoading,
} from './occupation.actions';
import { initialUIState } from './occupation.state';

export const occupationReducer = createReducer(
  initialUIState,
  on(toggleOccupationLoading, (state, { isLoading }) => ({
    ...state,
    isLoading,
  })),
  on(loadOccupationSuccess, (state, { occupation }) => ({
    ...state,
    list: occupation,
    isLoading: false,
  })),
  on(loadOccupationFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
);
